<template>
  <section class="event-card_v2">
    <article class="event-card_v2__image-container">
      <KenticoImage class="event-card_v2__image" :src="image.url" :alt="image.description" :sizes="imageSizes" />
    </article>
    <article class="event-card_v2__title">
      {{ primaryContent || secondaryContent }}
    </article>
    <p v-if="body" class="event-card_v2__intro body">{{ body }}</p> <p v-if="!body && promoBody" class="event-card_v2__intro" v-html="promoBody" />
    <nuxt-link v-if="linkedBlog[0].slug" :to="linkedBlog[0].slug" class="event-card_v2__link" @click.native="collectData"> {{ linkText }}<Chevron class="event-card_v2__link-arrow" /></nuxt-link>
    <a v-if="!linkedBlog[0].slug && promoLink" :href="promoLink" target="_blank" class="event-card_v2__link">{{ linkText }} <Chevron class="event-card_v2__link-arrow" /></a>
  </section>
</template>

<script>
import Chevron from '~/assets/icons/chevron.svg?inline';
import { clickedCta } from '~/utils/gtm-events.js';

export default {

  components: { Chevron },
  props: {
    // Content
    title: { type: String, default: '' },
    primaryContent: { type: String, default: '' },
    secondaryContent: { type: String, default: '' },
    promoLink: { type: String, default: '' },
    promoBody: { type: String, default: '' },
    body: { type: String, default: '' },
    linkedBlog: { type: Array, default() {
      return [{
        slug: '',
      }];
    } },
    image: {
      type: Object,
      required: false,
      default() {
        return {
          url: { type: String, required: true },
          description: { type: String, required: true },
        };
      },
    },
  },
  data() {
    return {
      linkText: 'Read the full story',
      imageSizes: {
        default: [610, 593],
      } };
  },
  computed: {
  },
  methods: {
    collectData() {
      clickedCta(this.$gtm, this.linkText, null, null, this.linkedBlog[0].slug);
    },
  },
};
</script>

<style lang="scss">
@import '~/assets/scss/atomic/components/_event-card-v2.scss';
</style>
